import React, { useState, useEffect } from "react";
import {

  Alert,
  Chip,
  Card,
  CardContent,
  Box,
} from "@mui/material";

import getTags from "../../api/store/getTags"; 
import NotificationSetting from "./component/NotificationSetting";

function NewsPage() {
  const [tags, setTagsState] = useState([]);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);


  useEffect(() => {
    const fetchTags = async () => {
      try {
        const data = await getTags();

        setTagsState(data.tags); // Adjust this if data structure differs
      } catch (err) {
        setError("Failed to load tags: " + err.message);
      }
    };

    fetchTags();
  }, []);


  return (
    <div>

      <NotificationSetting></NotificationSetting>
      {isSuccess && <Alert severity="success">操作成功！</Alert>}
      {error && <Alert severity="error">{error}</Alert>}
    </div>
  );
}

export default NewsPage;
